import { render, staticRenderFns } from "./mortgage-amortization-breakdown-table.vue?vue&type=template&id=530db122"
import script from "./mortgage-amortization-breakdown-table.vue?vue&type=script&lang=js"
export * from "./mortgage-amortization-breakdown-table.vue?vue&type=script&lang=js"
import style0 from "../../../assets/styles/amortization-breakdown-table.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports